export const STEP = {
  CUSTOMER: 1,
  PERSON: 2,
  DELIVERY_HOURS: 3,
  IMAGES: 4
};
